document.addEventListener("DOMContentLoaded", function () {
  var partnerSlider = document.querySelector(".partner-slider");
  if (partnerSlider) {
    var splide = new Splide(partnerSlider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 6,
      arrows: false,       // Hides previous/next arrows
      pagination: false,   // Hides navigation dots
      autoScroll: {
        speed: 1,
      },
        breakpoints: {
        989: {
          perPage: 4,
        },
        480: {
          perPage: 2,
        },
      },
    });

    splide.mount({ AutoScroll: window.splide.Extensions.AutoScroll });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".main-grid-col.splide");

  if (maingrid) {
    var splide = new Splide(".main-grid-col.splide", {
      type: "slide",
      rewind: true,
      perPage: 3,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false, // Set to true if you want Splide bullets
      drag: true,
      arrows: false, // We're using custom arrows
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = splide.root.querySelector(".current-slide");
    var totalEl = splide.root.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      // Update progress bar
      var rawProgress = (100 * index) / end;
      if (bar) {
        bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";
      }

      // Update counter
      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = splide.root.querySelector(".splide-prev-new");
      const nextBtn = splide.root.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});


document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".testimonials-slider");
    const prevBtn = document.querySelector(".testimonial-arrow--prev");
    const nextBtn = document.querySelector(".testimonial-arrow--next");

    if (slider && prevBtn && nextBtn && window.Flickity) {
      const flkty = new Flickity(slider, {
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        pageDots: false,
      });

      // Height Fix for multiple slides
      function setMaxSlideHeight(flkty) {
        let maxHeight = 0;
        const slides = flkty.slider.querySelectorAll(".testimonials-slide");

        slides.forEach((slide) => {
          slide.style.height = "auto"; // reset
          const height = slide.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        });

        flkty.viewport.style.height = `${maxHeight}px`;
      }

      flkty.on("ready", () => setMaxSlideHeight(flkty));
      flkty.on("change", () => setMaxSlideHeight(flkty));
      window.addEventListener("resize", () => setMaxSlideHeight(flkty));

      prevBtn.addEventListener("click", function () {
        flkty.previous();
      });

      nextBtn.addEventListener("click", function () {
        flkty.next();
      });
    }
  });



function updateCartTotalInHeader() {
fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    const total = (cart.total_price / 100).toFixed(2); // Convert cents to dollars
    const priceText = `$${total}`;
    const cartPriceEl = document.getElementById('CartTotalHeader');
    if (cartPriceEl) {
      cartPriceEl.textContent = priceText;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".giving-back-slide.splide");

  if (maingrid) {
    var splide = new Splide(".giving-back-slide.splide", {
      type: "slide",
      rewind: true,
      perPage: 3,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: false,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = document.querySelector(".current-slide");
    var totalEl = document.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      // Update progress bar
      var rawProgress = (100 * index) / end;
      bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";

      // Update counter
      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".relate-grid-col.splide");

  if (maingrid) {
    var splide = new Splide(".relate-grid-col.splide", {
      type: "slide",
      rewind: true,
      perPage: 4,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: false,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = document.querySelector(".current-slide");
    var totalEl = document.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      // Update progress bar
      var rawProgress = (100 * index) / end;
      bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";

      // Update counter
      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".promoslide.splide");
  const barWrap = document.querySelector(".bar_wrap");

  if (maingrid) {
    const slideCount = maingrid.querySelectorAll(".splide__slide").length;
    const isDesktop = window.innerWidth > 989;

    // If slide count is 4 or fewer on desktop, hide progress bar
    if (slideCount <= 4 && isDesktop && barWrap) {
      barWrap.style.display = "none";
    }

    var splide = new Splide(".promoslide.splide", {
      type: "slide",
      rewind: true,
      perPage: 4,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: false,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = document.querySelector(".current-slide");
    var totalEl = document.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      if (bar) {
        var rawProgress = (100 * index) / end;
        bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";
      }

      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const maingrid = document.querySelector(".promoslidembl.splide");
  const barWrap = document.querySelector(".bar_wrap");

  if (!maingrid) return;

  const slideCount = maingrid.querySelectorAll(".splide__slide").length;
  const isDesktop = window.innerWidth > 989;

  // Hide bar if not enough slides
  if (slideCount <= 4 && isDesktop && barWrap) {
    barWrap.style.display = "none";
  }

  const splide = new Splide(".promoslidembl.splide", {
    type: "slide",
    rewind: true,
    perPage: 4,
    perMove: 1,
    gap: "30px",
    autoplay: false,
    interval: 4000,
    pagination: false,
    drag: true,
    arrows: false,
    breakpoints: {
      989: {
        perPage: 2,
        gap: "18px",
      },
      480: {
        perPage: 1,
      },
    },
  });

  const bar = document.querySelector(".my-slider-progress-bar");
  const currentEl = document.querySelector(".current-slide");
  const totalEl = document.querySelector(".total-slides");
  const prevBtn = document.querySelector(".splide-prev-new");
  const nextBtn = document.querySelector(".splide-next-new");

  // Update progress bar and counter
  const updateSliderUI = () => {
    const end = splide.Components.Controller.getEnd() + 1;
    const index = splide.index + 1;

    if (bar) {
      const rawProgress = (100 * index) / end;
      bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";
    }

    if (currentEl) currentEl.textContent = index;
    if (totalEl) totalEl.textContent = end;
  };

  splide.on("mounted move", updateSliderUI);

  splide.mount();

  // Ensure arrows work
  if (prevBtn) prevBtn.addEventListener("click", () => splide.go("<"));
  if (nextBtn) nextBtn.addEventListener("click", () => splide.go(">"));

  // Force initial update
  updateSliderUI();
});


document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".imageblockslide.splide");
  const barWrap = document.querySelector(".bar_wrap");

  if (maingrid) {
    const slideCount = maingrid.querySelectorAll(".splide__slide").length;
    const isDesktop = window.innerWidth > 989;

    // If slide count is 4 or fewer on desktop, hide progress bar
    if (slideCount <= 4 && isDesktop && barWrap) {
      barWrap.style.display = "none";
    }

    var splide = new Splide(".imageblockslide.splide", {
      type: "slide",
      rewind: true,
      perPage: 3,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: false,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = document.querySelector(".current-slide");
    var totalEl = document.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      if (bar) {
        var rawProgress = (100 * index) / end;
        bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";
      }

      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".locatorcolumn.splide");
  const barWrap = document.querySelector(".bar_wrap");

  if (maingrid) {
    const slideCount = maingrid.querySelectorAll(".splide__slide").length;
    const isDesktop = window.innerWidth > 989;

    // If slide count is 4 or fewer on desktop, hide progress bar
    if (slideCount <= 4 && isDesktop && barWrap) {
      barWrap.style.display = "none";
    }

    var splide = new Splide(".locatorcolumn.splide", {
      type: "slide",
      rewind: true,
      perPage: 3,
      perMove: 1,
      gap: "30px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: false,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "18px",
        },
        480: {
          perPage: 1,
        },
      },
    });

    var bar = splide.root.querySelector(".my-slider-progress-bar");
    var currentEl = document.querySelector(".current-slide");
    var totalEl = document.querySelector(".total-slides");

    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var index = splide.index + 1;

      if (bar) {
        var rawProgress = (100 * index) / end;
        bar.style.width = Math.min(Math.max(rawProgress, 0), 100) + "%";
      }

      if (currentEl) currentEl.textContent = index;
      if (totalEl) totalEl.textContent = end;
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let maingrid = document.querySelector(".collectiontop.splide");

  if (maingrid) {
    const splide = new Splide(".collectiontop.splide", {
      type: "slide", // Prefer 'loop' for true center effect
      rewind: false, // Not needed with loop
      perPage: 3,
      perMove: 1,
      gap: "10px",
      autoplay: false,
      interval: 4000,
      pagination: false,
      drag: true,
      arrows: true,
      focus: "center",
      breakpoints: {
        989: {
          type: "loop",
          perPage: 2.5,
          gap: "18px",
        },
        480: {
          perPage: 1.5,
          padding: { left: "30px", right: "30px" },
        },
      },
    });

    splide.on("mounted", () => {
      const prevBtn = document.querySelector(".splide-prev-new");
      const nextBtn = document.querySelector(".splide-next-new");

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const scrollLink = document.querySelector('.scroll-down');
    const target = document.getElementById('CollectionAjaxContent');

    if (scrollLink && target) {
      scrollLink.addEventListener('click', function (e) {
        e.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  });

  

// Call on load
document.addEventListener('DOMContentLoaded', updateCartTotalInHeader);

// Optional: Call after any cart update (if AJAX cart used)
document.addEventListener('cart:updated', updateCartTotalInHeader);
